import React, {useEffect, useRef} from "react";
import classNames from "classnames";
import styles from "./SearchAutoGrow.module.scss";
import {Loader} from "components";
import colors from "styles/themes.module.scss";
import {TSearchAutogrowProps} from "./types";
import css from "../../../components/Inputs/TextInput/index.module.scss";

const SearchAutogrowInput = ({
	customWrapperClass,
	customInputClass,
	isLoading = false,
	loaderColor = colors.loaderDotColor,
	preIcon = null,
	onChange,
	value = "",
	maxHeight = 200,
	setInputHeight,
	errorText = "",
	...restProps
}: TSearchAutogrowProps) => {
	const textAreaRef = useRef<HTMLTextAreaElement>(null);

	const InlineLoaderComponent = (
		<Loader
			displayAtCenterOfPage={false}
			type={"ThreeDots"}
			height={20}
			width={20}
			color={loaderColor}
		/>
	);

	const resizeTextArea = () => {
		if (textAreaRef?.current) {
			textAreaRef.current.style.height = "auto";

			const scrollHeight = textAreaRef.current.scrollHeight;

			let height;

			if (scrollHeight < maxHeight) {
				height = textAreaRef.current.scrollHeight;
			} else {
				height = `${maxHeight}`;
			}

			textAreaRef.current.style.height = `${height}px`;

			if (setInputHeight) {
				setInputHeight(parseInt(height.toString()));
			}
		}
	};

	useEffect(resizeTextArea, [maxHeight, value, setInputHeight]);

	return (
		<div
			data-testid="search-input-container"
			className={classNames(styles.inputContainer, customWrapperClass && customWrapperClass)}
		>
			<div
				className={classNames(styles.inputWrapper, {
					[styles.error]: errorText,
				})}
			>
				{preIcon && preIcon}

				<textarea
					{...restProps}
					ref={textAreaRef}
					onChange={onChange}
					className={classNames(
						styles.searchInput,
						customInputClass && customInputClass,
						{
							[styles.errorInput]: errorText,
						},
					)}
					data-testid="search-input"
					rows={1}
					style={{paddingLeft: !preIcon ? 16 : 36}}
					value={value}
				/>

				{isLoading && (
					<span data-testid="inline-loader" className={styles.loader}>
						{InlineLoaderComponent}
					</span>
				)}
			</div>
			{errorText && (
				<span className={css.errorTextSpan} style={{opacity: errorText ? 1 : 0}}>
					{errorText}&nbsp;
				</span>
			)}
		</div>
	);
};

export default SearchAutogrowInput;
